import { render, staticRenderFns } from "./picture.vue?vue&type=template&id=4cfdcf83&scoped=true"
import script from "./picture.vue?vue&type=script&lang=js"
export * from "./picture.vue?vue&type=script&lang=js"
import style0 from "./picture.vue?vue&type=style&index=0&id=4cfdcf83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfdcf83",
  null
  
)

export default component.exports